import React, { useState, useEffect } from "react";
import { useUser } from "../../context/userContext";
import Sidebar from "../../components/Sidebar";
import axios from "axios";
import Modal from "../../components/Modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const Profile = () => {
  const { user, setUser } = useUser();
  const [isEmailVerified, setIsEmailVerified] = useState(
    user.verified || false
  );
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [updateProfileModalOpen, setUpdateProfileModalOpen] = useState(false);
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);
  const [deleteAccountModalOpen, setDeleteAccountModalOpen] = useState(false);
  const [newEmail, setNewEmail] = useState(user.email);
  const [newName, setNewName] = useState(user.name);
  const [newPhoneNumber, setNewPhoneNumber] = useState(user.phone_number);
  const [newAccountStatus, setNewAccountStatus] = useState(user.account_status);
  const [newRole, setNewRole] = useState(user.role);
  const [newVerified, setNewVerified] = useState(user.verified);
  const [newProfilePicture, setNewProfilePicture] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState({
    state: "",
    city: "",
    address: "",
    postal_code: "",
  });
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const [planName, setPlanName] = useState("");

  useEffect(() => {
    const fetchAdditionalInfo = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://api.theonlysale.com/api/additional-info/get/${user.id}`
        );
        if (response.data) {
          setAdditionalInfo(response.data);
        } else {
          setAdditionalInfo(null);
        }
      } catch (error) {
        console.error("Failed to fetch additional info", error);
        setAdditionalInfo(null);
      } finally {
        setLoading(false);
      }
    };

    const fetchSubscriptionInfo = async () => {
      try {
        const response = await axios.get(
          `https://api.theonlysale.com/api/subscription/get/user/${user.id}`
        );
        if (response.data) {
          setSubscriptionInfo(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch subscription info", error);
      }
    };

    fetchAdditionalInfo();
    fetchSubscriptionInfo();
  }, [user.id]);

  console.log("Aditional information", additionalInfo);
  console.log("fetchSubscriptionInfo", subscriptionInfo);

  useEffect(() => {
    if (subscriptionInfo) {
      const fetchPlanName = async () => {
        try {
          const response = await axios.get(
            `https://api.theonlysale.com/api/subscription/get/plan/${subscriptionInfo[0].plan}`
          );
          setPlanName(response.data.planName);
        } catch (error) {
          console.error("Error fetching plan name:", error);
        }
      };

      fetchPlanName();
    }
  }, [subscriptionInfo]);
  const handleAddAdditionalInfo = () => {
    setIsModalOpen(true); // Open the modal when the button is clicked
  };
  console.log("useri", user);

  const handleSaveAdditionalInfo = async () => {
    try {
      // Make POST request to the backend
      const response = await axios.post(
        `https://api.theonlysale.com/api/additional-info/post`,
        {
          user_id: user.id,
          state: additionalInfo.state,
          city: additionalInfo.city,
          address: additionalInfo.address,
          postal_code: additionalInfo.postal_code,
        }
      );

      // Success feedback
      toast.success("Additional info added successfully!");

      // Close modal after success
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error adding additional info:", error);
      toast.error("Failed to add additional info. Please try again.");
    }
  };
  const isAdditionalInfoEmpty = !additionalInfo;

  const updateUserContext = (newUserData) => {
    setUser((prevUser) => ({
      ...prevUser,
      ...newUserData,
    }));
  };
  const handleProfilePictureChange = (e) => {
    setNewProfilePicture(e.target.files[0]);
  };

  const handleSendVerification = async () => {
    try {
      await axios.post("https://api.theonlysale.com/api/send-verification", {
        email: user.email,
      });
      setModalOpen(true);
      setVerificationStatus("Verification code sent to your email.");
    } catch (error) {
      setVerificationStatus("Failed to send verification code.");
    }
  };

  const handleVerifyCode = async () => {
    try {
      await axios.post("https://api.theonlysale.com/api/verify-code", {
        email: user.email,
        code: verificationCode,
      });
      setVerificationStatus("Email verified successfully!");
      setIsEmailVerified(true);
      setModalOpen(false);
    } catch (error) {
      setVerificationStatus("Invalid or expired verification code.");
    }
  };

  const handleUpdateProfile = async () => {
    try {
      const userId = user.id;
      const formData = new FormData();
      formData.append("name", newName);
      formData.append("email", newEmail);
      formData.append("phone_number", newPhoneNumber);
      formData.append("account_status", newAccountStatus);
      formData.append("role", newRole);
      formData.append("verified", newVerified);

      if (newProfilePicture) {
        formData.append("image", newProfilePicture);
      }

      const response = await axios.put(
        `https://api.theonlysale.com/api/user/update/${userId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Profile updated successfully!");

      updateUserContext(response.data);
      setUpdateProfileModalOpen(false);
    } catch (error) {
      console.error("Failed to update profile", error);
      toast.error("Failed to update profile.");
    }
  };

  const handleChangePassword = async () => {
    try {
      const userId = user.id;

      await axios.put(
        `https://api.theonlysale.com/api/users/${userId}/change-password`,
        {
          oldPassword: currentPassword,
          newPassword: newPassword,
        }
      );

      setCurrentPassword("");
      setNewPassword("");

      setChangePasswordModalOpen(false);

      toast.success("Password changed successfully!");
    } catch (error) {
      console.error("Failed to change password", error);
      toast.error("Failed to change password. Please try again.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const handleDeleteAccount = async () => {
    try {
      const userId = user.id;

      await axios.delete(
        `https://api.theonlysale.com/api/user/delete/${userId}`
      );

      toast.success("Account deleted successfully!");

      handleLogout();
    } catch (error) {
      console.error("Failed to delete account", error);
      toast.error("Failed to delete account.");
    }
  };

  console.log(user);
  const imageFileName = user?.image?.split(/[\\/]/).pop();
  const imageURIs = `https://api.theonlysale.com/uploads/profile_pics/${imageFileName}`;

  const lastLoginDate = new Date(
    user.last_login || Date.now()
  ).toLocaleDateString();

  return (
    <>
      <Sidebar />
      <div className="bg-gray-100 dark:bg-gray-900 min-h-screen flex items-center justify-center py-6 px-4 sm:px-6 lg:px-8">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-lg w-full">
          <div className="flex flex-col items-center p-6">
            <img
              className="w-24 h-24 rounded-full object-cover mb-4"
              src={imageURIs}
              alt={user.name}
            />
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              {user.name}
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              {user.role.charAt(0).toUpperCase() + user.role.slice(1)} |{" "}
              {user.account_status}
            </p>

            <div className="w-full px-4 py-2 border-t border-gray-200 dark:border-gray-700">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Contact Information
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                <span className="font-medium">Email:</span> {user.email}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                <span className="font-medium">Phone:</span> {user.phone_number}
              </p>
            </div>

            <div className="w-full px-4 py-2 border-t border-gray-200 dark:border-gray-700">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Account Details
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                <span className="font-medium">Account Status:</span>{" "}
                {user.account_status}
              </p>

              <p className="text-sm text-gray-600 dark:text-gray-400">
                <span className="font-medium">Role:</span>{" "}
                {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                <span className="font-medium">Last Login:</span> {lastLoginDate}
              </p>
            </div>
            <div className="w-full px-4 py-2 border-t border-gray-200 dark:border-gray-700">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Subscription Information
              </h2>
              {subscriptionInfo ? (
                <div className="space-y-2">
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">Subscription plan:</span>
                    {planName}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">Subscription status:</span>{" "}
                    {subscriptionInfo[0].status}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">Start Date:</span>{" "}
                    {format(
                      new Date(subscriptionInfo[0].start_date),
                      "MMMM dd, yyyy, h:mm a"
                    )}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">End Date:</span>{" "}
                    {format(
                      new Date(subscriptionInfo[0].end_date),
                      "MMMM dd, yyyy, h:mm a"
                    )}
                  </p>
                  {subscriptionInfo.length > 0 &&
                    (() => {
                      const subscription = subscriptionInfo[0];
                      const endDate = subscription?.end_date
                        ? new Date(subscription.end_date)
                        : null;
                      const currentDate = new Date();

                      if (
                        subscription.status === "expired" ||
                        (endDate && endDate < currentDate)
                      ) {
                        return (
                          <Link to="/renew-subscription">
                            <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-500 transition duration-200">
                              Renew Subscription
                            </button>
                          </Link>
                        );
                      }

                      return null;
                    })()}
                </div>
              ) : (
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  No subscription information available.
                </p>
              )}
            </div>
            <div className="w-full px-4 py-2 border-t border-gray-200 dark:border-gray-700">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Additional Information
              </h2>
              {loading ? (
                <p>Loading...</p>
              ) : isAdditionalInfoEmpty ? (
                <button
                  onClick={handleAddAdditionalInfo}
                  className="text-sm bg-blue-500 text-white px-4 py-2 rounded-lg mt-2 hover:bg-blue-400"
                >
                  Add Additional Info
                </button>
              ) : (
                <div className="space-y-2">
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">State:</span>{" "}
                    {additionalInfo?.data?.state || "N/A"}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">City:</span>{" "}
                    {additionalInfo?.data?.city || "N/A"}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">Address:</span>{" "}
                    {additionalInfo?.data?.address || "N/A"}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">Postal Code:</span>{" "}
                    {additionalInfo?.data?.postal_code || "N/A"}
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="w-full px-4 py-2 border-t border-gray-200 dark:border-gray-700">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Email Verification
            </h2>
            {!isEmailVerified ? (
              <button
                onClick={handleSendVerification}
                className="text-sm bg-yellow-500 text-white px-4 py-2 rounded-lg mt-2 hover:bg-yellow-400"
              >
                Verify Email
              </button>
            ) : (
              <p className="text-sm text-green-600">Email Verified</p>
            )}
          </div>
          <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title="Add Additional Info"
          >
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  State
                </label>
                <input
                  type="text"
                  className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md"
                  value={additionalInfo?.state}
                  onChange={(e) =>
                    setAdditionalInfo({
                      ...additionalInfo,
                      state: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  City
                </label>
                <select
                  id="city"
                  value={additionalInfo?.city}
                  onChange={(e) =>
                    setAdditionalInfo({
                      ...additionalInfo,
                      city: e.target.value,
                    })
                  }
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                  required
                >
                  <option value="">Select City</option>
                  <option value="Zurich">Zurich</option>
                  <option value="Geneva">Geneva</option>
                  <option value="Basel">Basel</option>
                  <option value="Bern">Bern</option>
                  <option value="Lucerne">Lucerne</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Address
                </label>
                <input
                  type="text"
                  className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md"
                  value={additionalInfo?.address}
                  onChange={(e) =>
                    setAdditionalInfo({
                      ...additionalInfo,
                      address: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Postal Code
                </label>
                <input
                  type="text"
                  className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md"
                  value={additionalInfo?.postal_code}
                  onChange={(e) =>
                    setAdditionalInfo({
                      ...additionalInfo,
                      postal_code: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={handleSaveAdditionalInfo}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-400"
                >
                  Save
                </button>
              </div>
            </div>
          </Modal>

          {modalOpen && (
            <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
              <div className="p-4">
                <h2 className="text-xl font-semibold mb-2">
                  Enter Verification Code
                </h2>
                <input
                  type="text"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  placeholder="Enter code"
                  className="p-2 border rounded w-full"
                />
                <button
                  onClick={handleVerifyCode}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg mt-2 hover:bg-blue-500"
                >
                  Verify Code
                </button>
                {verificationStatus && (
                  <p className="text-sm mt-2">{verificationStatus}</p>
                )}
              </div>
            </Modal>
          )}

          {updateProfileModalOpen && (
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
              <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-lg mx-auto">
                <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-white">
                  Update Profile
                </h2>

                <div className="space-y-4">
                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                      htmlFor="email"
                    >
                      Email
                    </label>
                    <input
                      id="email"
                      type="email"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      placeholder="Enter new email"
                      className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-white"
                    />
                  </div>
                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                      htmlFor="name"
                    >
                      Name
                    </label>
                    <input
                      id="name"
                      type="text"
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                      placeholder="Enter new name"
                      className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-white"
                    />
                  </div>
                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                      htmlFor="phone"
                    >
                      Phone Number
                    </label>
                    <input
                      id="phone"
                      type="tel"
                      value={newPhoneNumber}
                      onChange={(e) => setNewPhoneNumber(e.target.value)}
                      placeholder="Enter new phone number"
                      className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-white"
                    />
                  </div>

                  {/* Account Status */}
                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                      htmlFor="status"
                    >
                      Account Status
                    </label>
                    <input
                      id="status"
                      type="text"
                      value={newAccountStatus}
                      readOnly
                      className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-800 dark:text-white"
                    />
                  </div>
                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                      htmlFor="role"
                    >
                      Role
                    </label>
                    <input
                      id="role"
                      type="text"
                      value={newRole}
                      readOnly
                      className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-100 dark:bg-gray-800 dark:text-white"
                    />
                  </div>
                  <div className="flex items-center">
                    <input
                      id="verified"
                      type="checkbox"
                      checked={newVerified}
                      onChange={() => setNewVerified(!newVerified)}
                      className="h-4 w-4 text-blue-600 border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-blue-500"
                    />
                    <label
                      htmlFor="verified"
                      className="ml-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      Verified
                    </label>
                  </div>
                  <input type="file" onChange={handleProfilePictureChange} />
                </div>

                <div className="mt-6 flex justify-end">
                  <button
                    onClick={handleUpdateProfile}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    Update Profile
                  </button>
                  <button
                    onClick={() => setUpdateProfileModalOpen(false)}
                    className="ml-2 bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {changePasswordModalOpen && (
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
              <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-md mx-auto">
                <h2 className="text-xl font-semibold mb-4 text-gray-800 dark:text-white">
                  Change Password
                </h2>
                <input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="Enter current password"
                  className="p-3 w-full mb-4 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 dark:text-white"
                />
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  className="p-3 w-full mb-4 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 dark:text-white"
                />
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={handleChangePassword}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-500 mr-2"
                  >
                    Change Password
                  </button>
                  <button
                    onClick={() => setChangePasswordModalOpen(false)}
                    className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg shadow-lg hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {deleteAccountModalOpen && (
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
              <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-md mx-auto">
                <h2 className="text-xl font-semibold mb-4 text-gray-800 dark:text-white">
                  Delete Account
                </h2>
                <p className="text-gray-700 dark:text-gray-300">
                  Are you sure you want to delete your account? This action is
                  irreversible.
                </p>
                <p className="text-red-600 dark:text-red-400 mt-2">
                  Please note: Deleting your account will also delete all
                  associated products.
                </p>
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={handleDeleteAccount}
                    className="bg-red-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-red-500 mr-2"
                  >
                    Yes, Delete Account
                  </button>
                  <button
                    onClick={() => setDeleteAccountModalOpen(false)}
                    className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg shadow-lg hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="w-full px-4 py-4 border-t border-gray-200 dark:border-gray-700">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Profile Settings
            </h2>
            <div className="flex space-x-4">
              <button
                onClick={() => setUpdateProfileModalOpen(true)}
                className="text-sm bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-500 transition duration-200 ease-in-out"
              >
                Update Profile
              </button>
              <button
                onClick={() => setChangePasswordModalOpen(true)}
                className="text-sm bg-red-600 text-white px-4 py-2 rounded-lg shadow hover:bg-red-500 transition duration-200 ease-in-out"
              >
                Change Password
              </button>
            </div>

            <div className="mt-6 border-t border-gray-200 dark:border-gray-700 pt-4">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Account Management
              </h2>
              <button
                onClick={() => setDeleteAccountModalOpen(true)}
                className="text-sm bg-red-700 text-white px-4 py-2 rounded-lg shadow hover:bg-red-600 transition duration-200 ease-in-out"
              >
                Delete Account
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Profile;
